import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import days from 'dayjs';
import lf from 'dayjs/plugin/localizedFormat';

import { getAppById } from '../services/storeServices';
import { loggedValidation } from '../redux/ducks/userDuck';

import Container from '../components/Container';
import Header from '../components/Header';
import AppIcon from '../components/AppIcon';
import Text from '../components/Text';
import SoIcon from '../components/SoIcon';
import VersionItem from '../components/VersionItem';

function AppDetail({
  loggedValidation,
}) {
  const params = useParams();
  const [app, setApp] = useState({});
  days.extend(lf);
  days.locale('es');

  useEffect(() => {
    getAppById(params.appid)
      .then(data => data && setApp(data))
      .catch(error => console.log(error));
  }, [app.name]);

  useEffect(() => {
    loggedValidation();
  }, []);

  console.log(app);

  return (
    <Container bgColor="light" className="app-detail-screen">
      <Header />
      <div className="app-container">
        <div className="app-info">
          <div className="app-icon">
            <AppIcon size="xlarge" appName={app.name} icon={app.icon} />
            <Text level="h3">
              { app.name }
            </Text>
            <SoIcon so={app.so} />
          </div>

          <p>
            { app.description }
          </p>
        </div>
        <div className="app-versions">
          <Text level="h3" textColor="highlight">
            {`Versiones de prueba disponibles para ${app.so === 'ios' ? 'iOS' : 'Android'}`}
          </Text>
          <div className="app-versions-items">
            {
              app.versions && app.versions.map(v => {
                return <VersionItem
                  versionNumber={v.version}
                  date={v.release_date && days.unix(v.release_date.seconds).format('LL')}
                  reference={v.file_url}
                />
              })
            }
          </div>
        </div>
      </div>
    </Container>
  );
}

export default connect(
  null, {
    loggedValidation,
  }
)(AppDetail);
